import * as React from "react";
import { Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

export default function ChatHeader({ title, onRequestDelete }) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, px: 2, py: 1, minHeight: 48 }}>
            <Typography variant="subtitle1" noWrap sx={{ fontWeight: 600, minWidth: 0 }}>
                {title || "New chat"}
            </Typography>
            <IconButton size="small" aria-label="Chat actions" onClick={(event) => setAnchorEl(event.currentTarget)}>
                <KeyboardArrowDownIcon />
            </IconButton>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
                <MenuItem
                    onClick={() => {
                        setAnchorEl(null);
                        onRequestDelete();
                    }}
                >
                    <ListItemIcon>
                        <DeleteOutlineIcon fontSize="small" color="error" />
                    </ListItemIcon>
                    <ListItemText primary="Delete chat" primaryTypographyProps={{ color: "error" }} />
                </MenuItem>
            </Menu>
        </Box>
    );
}
